// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style-module_warningIcon__tYbFbni4V7hFlzklAtpB"};